import {
    REQUEST_ALL_SETTINGS,
    REQUEST_ALL_SETTINGS_ERROR,
    ADD_ALL_SETTINGS,
    SET_PENDING_VALUE,
    CLEAR_SETTINGS,
} from './actions';

const initialState = {
    'account.facialRecognition.enabled': undefined,
    'user.general.unitOfMeasure': undefined,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_ALL_SETTINGS: {
            return {
                ...state,
                loading: true,
            };
        }
        case REQUEST_ALL_SETTINGS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        }
        case ADD_ALL_SETTINGS: {
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        }
        case SET_PENDING_VALUE: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case CLEAR_SETTINGS: {
            return initialState;
        }
        default:
            return state;
    }
};

export default reducer;
